import ActivoService from 'src/modules/activo/activoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'ACTIVO_VIEW';

const activoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: activoViewActions.FIND_STARTED,
      });

      const record = await ActivoService.find(id);

      dispatch({
        type: activoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: activoViewActions.FIND_ERROR,
      });

      getHistory().push('/activo');
    }
  },
};

export default activoViewActions;
